import { createSlice } from '@reduxjs/toolkit'
import {
    countAllUsersByTenant,
    countConnectedUsersByTenant,
    countConnectedGuestByTenant,
    tenantsMap,
    CountAllUsersByTenantByMap,
    StatConnectedUsers,
    StatConnectedGuest,
    StatAllConnectedByTenantByMap,
    StatInvitationSent,
    StatMessages,
    StatAllCommunicationByTenantByMap,
    ActiveAccounts,
    getTenantMonthlyReport
} from './statisticsThunks'

const initialState = {
    successMessage: null,
    error: null,
    usersCount: 0,
    connectedUsersCount: 0,
    connectedGuestCount: 0,
    tenantsMapList: [],
    users: [],
    countAllUsersByTenantByMap: null,
    statConnectedUsers: null,
    statConnectedGuest: null,
    mergedPoints: [],
    invitationCount: null,
    messagesCount:null,
    communicationCount:null,
    activeAccounts: 0 ,
    reportData : null
}


const statisticsSlice = createSlice({
    name: 'statistics',
    initialState,
    reducers: {
        setSuccessMessage: (state, action) => {
            state.successMessage = action.payload
        },
        setUsersCount: (state, action) => {
            state.usersCount = action.payload
        },
        setUsers: (state, action) => {
            const sortedResult = action.payload.sort((a, b) => {
                const aConnected = a.socket_id !== null;
                const bConnected = b.socket_id !== null;

                if (aConnected !== bConnected) {
                    return aConnected ? -1 : 1;
                }
                return a.display_name.localeCompare(b.display_name);
            });
            state.users = sortedResult;
        },
        setError: (state, action) => {
            state.error = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            /////countAllUsersByTenant 
            .addCase(countAllUsersByTenant.pending, (state) => {
                state.error = null;
            })
            .addCase(countAllUsersByTenant.fulfilled, (state, action) => {
                state.usersCount = action.payload;
            })
            .addCase(countAllUsersByTenant.rejected, (state, action) => {
                state.error = action.payload || 'Failed to get users Count';
            })
            /////countConnectedUsersByTenant 
            .addCase(countConnectedUsersByTenant.pending, (state) => {
                state.error = null;
            })
            .addCase(countConnectedUsersByTenant.fulfilled, (state, action) => {
                state.connectedUsersCount = action.payload;
            })
            .addCase(countConnectedUsersByTenant.rejected, (state, action) => {
                state.error = action.payload || 'Failed to get connected Users Count';
            })
            /////countConnectedGuestByTenant 
            .addCase(countConnectedGuestByTenant.pending, (state) => {
                state.error = null;
            })
            .addCase(countConnectedGuestByTenant.fulfilled, (state, action) => {
                state.connectedGuestCount = action.payload;
            })
            .addCase(countConnectedGuestByTenant.rejected, (state, action) => {
                state.error = action.payload || 'Failed to get connected Guest Count';
            })
            /////map tenants
            .addCase(tenantsMap.pending, (state) => {
                state.error = null;
            })
            .addCase(tenantsMap.fulfilled, (state, action) => {
                state.tenantsMapList = action.payload;
            })
            .addCase(tenantsMap.rejected, (state, action) => {
                state.error = action.payload || 'Failed to get connected Guest Count';
            })
            /////countActiveAccountByMapTenant
            .addCase(ActiveAccounts.pending, (state) => {
                state.error = null;
            })
            .addCase(ActiveAccounts.fulfilled, (state, action) => {
                state.activeAccounts = action.payload;
            })
            .addCase(ActiveAccounts.rejected, (state, action) => {
                state.error = action.payload || 'Failed to get connected Guest Count';
            })
            /////countConnectedGuestByMapTenant
            .addCase(CountAllUsersByTenantByMap.pending, (state) => {
                state.error = null;
            })
            .addCase(CountAllUsersByTenantByMap.fulfilled, (state, action) => {
                state.countAllUsersByTenantByMap = action.payload;
            })
            .addCase(CountAllUsersByTenantByMap.rejected, (state, action) => {
                state.error = action.payload || 'Failed to get connected Guest Count';
            })
            /////StatConnectedUsers
            .addCase(StatConnectedUsers.pending, (state) => {
                state.error = null;
            })
            .addCase(StatConnectedUsers.fulfilled, (state, action) => {
                state.statConnectedUsers = action.payload;
            })
            .addCase(StatConnectedUsers.rejected, (state, action) => {
                state.error = action.payload || 'Failed to get connected Guest Count';
            })
            /////StatConnectedGuest
            .addCase(StatConnectedGuest.pending, (state) => {
                state.error = null;
            })
            .addCase(StatConnectedGuest.fulfilled, (state, action) => {
                state.statConnectedGuest = action.payload;
            })
            .addCase(StatConnectedGuest.rejected, (state, action) => {
                state.error = action.payload || 'Failed to get connected Guest Count';
            })
            /////////////
            .addCase(StatAllConnectedByTenantByMap.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(StatAllConnectedByTenantByMap.fulfilled, (state, action) => {
                state.loading = false;
                state.mergedPoints = action.payload;
            })
            .addCase(StatAllConnectedByTenantByMap.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Erreur lors du chargement";
            })
            /////////////
            .addCase(StatInvitationSent.pending, (state) => {
                state.error = null;
            })
            .addCase(StatInvitationSent.fulfilled, (state, action) => {
                state.invitationCount = action.payload;
            })
            .addCase(StatInvitationSent.rejected, (state, action) => {
                state.error = action.payload || "Erreur lors du chargement";
            })
            /////////////
            .addCase(StatMessages.pending, (state) => {
                state.error = null;
            })
            .addCase(StatMessages.fulfilled, (state, action) => {
                state.messagesCount = action.payload;
            })
            .addCase(StatMessages.rejected, (state, action) => {
                state.error = action.payload || "Erreur lors du chargement";
            })
            /////////////
            .addCase(StatAllCommunicationByTenantByMap.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(StatAllCommunicationByTenantByMap.fulfilled, (state, action) => {
                state.loading = false;
                state.communicationCount = action.payload;
            })
            .addCase(StatAllCommunicationByTenantByMap.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Erreur lors du chargement";
            })

          .addCase(getTenantMonthlyReport.fulfilled, (state, action) => {
                state.reportData = action.payload;
            })
            .addCase(getTenantMonthlyReport.rejected, (state, action) => {
                state.error = action.payload || "Erreur lors du chargement";
            });
    },


})

export const {
    setSuccessMessage,
    setUsersCount,
    setUsers,
    setError
} = statisticsSlice.actions




export default statisticsSlice.reducer